export enum Steps {
  CarTypesList = 1,
  ModelSelection = 2,
  ModificationsList = 3,
  GroupList = 4,
  Parts = 5,
  Scheme = 6,
  Filters = 7,
}
